import React from 'react';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  DISPLAY_TYPE,
  createButtonObject,
} from '../../components/organisms/BlockInteractions';
import { Icons } from '../../components/atoms/SVG';
import { Namespace } from '../../translation/namespace';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { asFetchableBlock, useBlockContext, useRefreshBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';
import { PageLeadBlockDefaultView } from './views/PageLeadBlockDefaultView';
import { PageLeadBlockEditForm } from './form/PageLeadBlockEditForm';
import { PageLeadBlockEditView } from './views/PageLeadBlockEditView';
import { isNullOrUndefined } from '../../lib/typeGuards';
import { PageLeadDefault } from '../../_lib/components/PageLead';

type PageLeadBlockProps = Views<DefaultView<PageLeadBlockDefaultView> & OptionalEditView<PageLeadBlockEditForm>> & {
  invisible: boolean;
};

function PageLead({ views, invisible, activeView }: PageLeadBlockProps) {
  const { t } = useSonTranslation('PageLead');
  const { uuid, elementType } = useBlockContext();
  const { refreshCount } = useRefreshBlock();

  /**
   * GenericForm for Editing PageLeads in every (future) page.
   * currently relies on default view to be present to show the h1 when in edit mode.
   */
  const getGenericPageLeadEditForm = () => {
    if (views.edit && isNullOrUndefined(views.edit?.embedded?.form)) {
      return null;
    }
    return views.edit && <PageLeadBlockEditView title={views.default.embedded.title} form={views.edit.embedded.form} />;
  };

  const createButtonsObject = () => {
    return createButtonObject(
      BlockInteractionsViews.EDIT,
      Icons.EDIT_PENCIL,
      `${Namespace.PageLead}:actions.edit`,
      DISPLAY_TYPE.COLLAPSIBLE,
      getGenericPageLeadEditForm(),
    );
  };

  if (invisible) {
    return <PageLeadDefault invisible title={views.default.embedded.title} />;
  }
  return (
    <BlockInteractions
      headline={{
        text: t('headline'),
        hierarchy: 2,
        visible: true,
      }}
      alwaysShowInfo={false}
      views={views}
      activeView={activeView}
      buttons={createButtonsObject()}
      refreshCount={refreshCount}
      uuid={uuid}
      elementType={elementType}
    >
      <PageLeadBlockDefaultView {...views.default} />
    </BlockInteractions>
  );
}

export const PageLeadBlock = asFetchableBlock(PageLead, BlockType.pagelead);
